/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';
import { Channel } from '../../common/types/types';

interface UpdateChannelConfigMutationProps {
    channel: Channel;
    options: object;
}

export default class UpdateChannelConfigMutation extends Relay.Mutation<UpdateChannelConfigMutationProps> {

    static propTypes = {
        channel: PropTypes.object.isRequired,
        options: PropTypes.object.isRequired,
    };

    static fragments = {
        channel: () => Relay.QL`
              fragment on Channel {
                    organisation_id,
                    id,
                    options,
                    authOptions,
                    currentUserOptions,
              }
            `,
    };

    getMutation() {
        return Relay.QL`mutation {updateChannelConfig}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on UpdateChannelConfigPayload {
                success,
                message,
                updatedNode {
                    id,
                    options,
                    activated,
                    authOptions,
                    currentUserOptions,
                    invalid,
                    failedAuthAttempts,
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            channel_id: this.props.channel.id,
            organisation_id: this.props.channel.organisation_id,
            options: JSON.stringify(this.props.options),
            currentUserOptions: JSON.stringify(this.props.currentUserOptions),
        };
    }
}
